export default __webpack_public_path__ + "static/media/travelInsurance.56fc9e12.svg";